import { NgModule } from '@angular/core';
import { TourListComponent } from './tour-list/tour-list.component';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/*';
import { RouterModule } from '@angular/router';

@NgModule({
    declarations: [
        TourListComponent
    ],
    imports: [TranslateModule, CommonModule, SharedModule, RouterModule],
    exports: [
        TourListComponent
    ]
})
export class ToursModule {

}
